// known duplication with @services/billing, but need to be here to avoid circular dependency
export enum UsageEntity {
  USERS = 'users',
  PROGRAMS = 'programs',
  COLLABORATIONS = 'collaborations',
  BAM_CREATORS = 'BAM_creators',
  SALES_TRACKING = 'sales_tracking',
  SHOPIFY_CUSTOMER_SYNC = 'shopify_customer_sync',
  MAX_MEMBERS_PER_STANDARD_PROGRAM = 'max_members_per_standard_program',
  MAX_MEMBERS_PER_FLEXIBLE_PROGRAM = 'max_members_per_flexible_program',
}

export interface IUsageLimits {
  [UsageEntity.USERS]?: number;
  [UsageEntity.PROGRAMS]?: number;
  [UsageEntity.COLLABORATIONS]?: number;
  [UsageEntity.BAM_CREATORS]?: number;
  [UsageEntity.SALES_TRACKING]?: boolean;
  [UsageEntity.SHOPIFY_CUSTOMER_SYNC]?: boolean;
  [UsageEntity.MAX_MEMBERS_PER_STANDARD_PROGRAM]?: number | null;
  [UsageEntity.MAX_MEMBERS_PER_FLEXIBLE_PROGRAM]?: number | null;
}
